module.exports = __webpack_public_path__ + "static/media/tacos.f52e5f63.jpg";